import { Badge } from 'antd';
import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { ProjectConversationId, ProjectId } from 'api/models';
import { useTranslation } from 'hooks/use-translation';
import { useProjectConversationTotalUnreadCount } from '../../proj-conversation-hooks';

const Count = styled(Badge)`
  left: 4px;

  sup {
    background: var(--ozone-red-background);
  }
`;

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ConversationMenuItem: FC<{ projectId: ProjectId }> = ({
  projectId,
}) => {
  const chat = useTranslation('projects.conversations.title');
  const { chatId } = useParams<{ chatId: string }>();

  // Only sent convId if user is on conversations page
  const activeConversationId = chatId
    ? ProjectConversationId(Number(chatId))
    : undefined;
  const unreadConversationsCount = useProjectConversationTotalUnreadCount(
    projectId,
    activeConversationId,
  );

  return (
    <StyledContainer data-test-id="projects.conversations.title">
      {chat}
      <Count count={unreadConversationsCount} />
    </StyledContainer>
  );
};
